const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/PDFViewer/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        pinchZoomDisabledInDrawingMode: 'Zoomen und Scrollen mit zwei Fingern sind im Zeichenmodus nicht verfügbar.',
        saveSignature: 'Speichern',
    },
    __RELATIVE_SOURCE_FILE__
);
